import React, { useState } from "react";

const ProgressBar = ({ progress, progressText }) => {
  const [isHovered, setIsHovered] = useState(false);
  const baseR = 210;
  const baseG = 50;
  const baseB = 50;
  
  const darkenFactor = 1 - (Math.min(progress, 100) / 100) * 0.7;
  const r = Math.round(baseR * darkenFactor);
  const g = Math.round(baseG * darkenFactor);
  const b = Math.round(baseB * darkenFactor);

  return (
    <div
      className="progress-bar"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="progress-bar__fill "
        style={{
          width: `${progress}%`,
          backgroundColor: `rgb(${r}, ${g}, ${b})`,
        }}
      ></div>
      <p className="progressText">
        {isHovered ? `${Math.min(progress.toFixed(2), 100)}%` : progressText}
      </p>
    </div>
  );
};

export default ProgressBar;
